<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="value"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="value"
        :label="$t(label)"
        :prepend-icon="icon"
        readonly
        :color="color"
        v-on="!readonly && on"
      >
        <v-tooltip slot="append" bottom v-if="$t(description)">
          <template v-slot:activator="{ on }">
            <v-icon slot="activator" v-on="on">mdi-help-circle</v-icon>
          </template>
          <span>{{ $t(description) }}</span>
        </v-tooltip>
      </v-text-field>
    </template>
    <v-time-picker
      v-if="menu"
      ref="picker"
      v-model="value"
      v-on:change="$refs.menu.save(value)"
      :color="color"
      format="24hr"
    ></v-time-picker>
  </v-menu>
</template>

<script>
import baseTextInput from '@/mixins/baseTextInput';

export default {
  mixins: [
    baseTextInput,
  ],
  props: {
    label: {
      type: String,
      default: 'fields.time',
    },
    description: {
      type: String,
      default: 'fields.timeTooltip',
    },
  },
  data: () => ({
    value: '00:00',
    menu: false,
  }),
  created() {
    // Default value is handle in baseTextInput mixin
    const [hours, minutes] = this.value.split(':');
    // If value is not valid force empty
    if (Number.isNaN(Number(hours)) || Number.isNaN(Number(minutes))) {
      this.value = '';
    }
  },
};
</script>
